export default __webpack_public_path__ + "static/media/up_dark.1ffb2ee2.png";